import React from 'react';
import EmailTemplateBuilder from './components/EmailTemplateBuilder';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <EmailTemplateBuilder />
    </div>
  );
}

export default App;
